import { useState, useEffect, Fragment, useMemo } from "react";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import StandByForm from "src/components/outside/standby/standbyForm";
import UserInfo from "src/components/common/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import {
    outsideHolidays, 
    standbyExceptionEmails, 
    statusColorCode, 
    weeknum, 
    weekDays, 
    getDateEndFromWeekNum, 
    myAxios, 
    exclusiveOutisdeKeys, 
    pmEmails, 
    MyDate, 
    isDevMode, 
    arrayReducer, 
    numberReducer, 
    changeWeek, 
    MyFormData, 
    getDatefromWeekNum, 
    getTimeStamp, 
    standbyWeeks as weeks,
    standbyReverseIndex as ri, 
    standbyCalculate as calc, 
    standbyTP as tp, 
    boolAndReducer,
    appTitle
} from "src/components/common/functions";
import Footer from "src/components/common/frame/footer";
import magnifierImg from "src/img/magnifier.png";
import PMReport from "./pmReport";
import DataReport from "./dataReport";
//--------------------------------------------------------------------------------------------
export default function OutsideStatusStandby({ tabTitle }){
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const forms = useMyStore((state) => state.outsideserviceStandbyForms);
    const setForms = useMyStore((state) => state.setOutsideserviceStandbyForms);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    const path2 = decodeURIComponent(path.split("/")[2] ?? "");
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Forms": forms.updatedAt === null?getTimeStamp():forms.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [week, setWeek] = useState((() => !weeks.includes(path2)?weeknum((new MyDate()).s()):path2));
    const [formEdit, setFormEdit] = useState({show: false});
    const [status, setStatus] = useState("");
    const [showExpense, setShowExpense] = useState(false);
    const [showMileage, setShowMileage] = useState(false);
    const [showPayroll, setShowPayroll] = useState(false);
    const [showBilling, setShowBilling] = useState(false);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);
    //--------------------------------------------------------------------------------------------
    const curForms = useMemo(() => forms[week] ?? [], [forms, week]);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredForms = useMemo(() => curForms.filter(f => 
        (!pmEmails.includes(f.email) || standbyExceptionEmails.includes(f.email)) && (week?(
        week >= weeknum(f.hireDate) &&
        (f.quitDate?week <= weeknum(f.quitDate):true) &&
        ((status === "Submitted")?f[week]?.status === "Submitted":
        (status === "Created"?f[week]?.status !== "Submitted":true))
        ):true) && 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(curForms)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))

    ), [curForms, week, status, filterWords]);
    const currentForms = filteredForms.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredForms.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const getFirstJobStart = day => day.slice(1).find(job => ![
        "Hotel Charges 3rd Party", 
        "Hotel Charges PGE",
        "Toll Charges 3rd Party", 
        "Toll Charges PGE", 
        "Lunch", 
        "Rest"
    ].includes(job.category))?.start ?? "";
    const getLastJobEnd = day => (day).slice(1).findLast(job => ![
        "Hotel Charges 3rd Party", 
        "Hotel Charges PGE",
        "Toll Charges 3rd Party", 
        "Toll Charges PGE", 
        "Lunch", 
        "Rest"
    ].includes(job.category))?.end ?? "";
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            //-------------------------------------------------
            const formData = new MyFormData();
            if(changeWeek(week, -1) !== "w2023-28"){
                formData.append("weeks", `\`standby\`.\`${week}\`,\`standby\`.\`${changeWeek(week, -1)}\``);
            }else{
                formData.append("weeks", `\`standby\`.\`${week}\``);
            }
            setShowLoading(true);
            const res = await myAxios("outside/standby/readTimeCards.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------------------------------
            //let ultimate = {};
            console.log(res.data)
            const unordered = res.data.map(
                person => Object.fromEntries(Object.entries(person).map(
                    ([key, value]) => {
                        if(!exclusiveOutisdeKeys.includes(key)){
                            const result = [key];
                            if(!value){
                                result.push({
                                    bS: "0.00", 
                                    bO: "0.00", 
                                    bS2: "0.00", 
                                    bO2: "0.00", 
                                    bS3: "0.00", 
                                    bO3: "0.00", 
                                    bT: "0.00", 
                                    s: "0.00", 
                                    o: "0.00",
                                    t: "0.00",
                                    data: [
                                        ...Array(7).fill([{}]),
                                    ], 
                                    expensesTotal: "0.00", 
                                    hotelExpensesTotal: "0.00", 
                                    tollExpensesTotal: "0.00", 
                                    // otherExpenses: [],
                                    // otherExpensesTotal: "0.00", 
                                    otherNotes: "",
                                    outside: person.outside, 
                                    region: "",
                                    status: "Created", 
                                    userName: person.userName, 
                                })
                            }else{
                                const weekData = JSON.parse(value);
                                weekData.userName = person.userName;
                                weekData.outside = person.outside;
                            
                                weekData.data = weekData.data.map((day, dayNum, days) => {
                                    if(day.length > 1){
                                        const overnight = (ri(getFirstJobStart(day)) + 96 - 
                                        (dayNum - 1 >= 0?
                                            ri(getLastJobEnd(days[dayNum - 1]))
                                            :
                                            (person[changeWeek(key, -1)]?
                                            (
                                                getLastJobEnd(JSON.parse(person[changeWeek(key, -1)]).data[6])?
                                                ri(getLastJobEnd(JSON.parse(person[changeWeek(key, -1)]).data[6]))
                                                :
                                                -Infinity
                                            )
                                            :
                                            -Infinity
                                        )
                                        )
                                        <= 32);
                                        const regularIndex = days[dayNum].findIndex(job => job.category === "Rest" && (ri(job.end) - ri(job.start)) > 32);
                                        const lessThan8 = jobNum => overnight && (regularIndex === -1?true:(jobNum < regularIndex));
                                        //----------------------------------------------------------------------------------
                                        const info = day[0];
                                        const billableJobNumber = day.slice(1).filter(job => 
                                            ![
                                                "Rest",
                                                "Lunch", 
                                                "Non Billable", 
                                                "Hotel Charges 3rd Party", 
                                                "Hotel Charges PGE",
                                                "Toll Charges 3rd Party", 
                                                "Toll Charges PGE"
                                            ].includes(job.category)
                                        ).length;
                                        const allJobs = day.slice(1).map((job, jobIndex, all) => {
                                            if(![
                                                "Rest",
                                                "Lunch", 
                                                "Hotel Charges 3rd Party", 
                                                "Hotel Charges PGE", 
                                                "Toll Charges 3rd Party", 
                                                "Toll Charges PGE"
                                            ].includes(job.category)){
                                                let t = 0, o = 0, s = 0, bS = 0, bO = 0, bS2 = 0, bO2 = 0, nb = 0, 
                                                bStart = job.start, bStartIndex = ri(job.start), bT = 0, partial = false;
                                                if(job.start && job.end){
                                                    t = (ri(job.end) - ri(job.start)) * 0.25;
                                                    if(
                                                        [
                                                            "Mob PGE", 
                                                            "DeMob PGE", 
                                                            "Mob 3rd Party", 
                                                            "DeMob 3rd Party"
                                                        ].includes(job.category) && 
                                                        (
                                                        jobIndex === all.findIndex(job => [
                                                            "Mob PGE", 
                                                            "DeMob PGE", 
                                                            "Mob 3rd Party", 
                                                            "DeMob 3rd Party"
                                                        ].includes(job.category)) 
                                                        || 
                                                        jobIndex === all.findLastIndex(job => [
                                                            "Mob PGE", 
                                                            "DeMob PGE", 
                                                            "Mob 3rd Party", 
                                                            "DeMob 3rd Party"
                                                        ].includes(job.category))
                                                        )
                                                    ){
                                                        if(t > 1){
                                                            bStartIndex = ri(job.start) + 4;
                                                            bStart = tp[bStartIndex].value;
                                                            const b2Hours = calc(ri(job.start), bStartIndex, dayNum >= 5 || outsideHolidays.map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(jobIndex));
                                                            bS2 = b2Hours.s;
                                                            bO2 = b2Hours.o;
                                                        }else{
                                                            partial = true;
                                                            const b2Hours = calc(ri(job.start), ri(job.end), dayNum >= 5 || outsideHolidays.map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(jobIndex));
                                                            bS2 = b2Hours.s;
                                                            bO2 = b2Hours.o;
                                                        }
                                                    }else if(["Non Billable"].includes(job.category)){
                                                        nb = 1;
                                                    }
                                                    const hours = calc(ri(job.start), ri(job.end), dayNum >= 5 || outsideHolidays.map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(jobIndex));
                                                    s = hours.s;
                                                    o = hours.o;
                                                    if(nb === 0 && !partial){
                                                        const bHours = calc(bStartIndex, ri(job.end), dayNum >= 5 || outsideHolidays.map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(jobIndex));
                                                        bS = bHours.s;
                                                        bO = bHours.o;
                                                    }
                                                    bT = bS + bO + bS2 + bO2;
                                                }
                                                const output = {
                                                    ...job, 
                                                    t: t.toFixed(2),
                                                    s: s.toFixed(2),
                                                    o: o.toFixed(2),
                                                    bStart: bStart,
                                                    bStartIndex: bStartIndex,
                                                    bS: bS.toFixed(2),
                                                    bO: bO.toFixed(2),
                                                    bS2: bS2.toFixed(2),
                                                    bO2: bO2.toFixed(2),
                                                    bT: bT.toFixed(2),
                                                    nb: nb
                                                };
                                                return output;
                                            }else if(["Rest", "Lunch"].includes(job.category)){
                                                return {
                                                    ...job, 
                                                    t: "0.00",
                                                    s: "0.00",
                                                    o: "0.00",
                                                    bS: "0.00",
                                                    bO: "0.00",
                                                    bS2: "0.00",
                                                    bO2: "0.00",
                                                    bT: "0.00",
                                                    nb: 1
                                                };
                                            }else{
                                                return job;
                                            }
                                        });
                                        const realJobs = allJobs.filter(job => ![
                                            "Hotel Charges 3rd Party", 
                                            "Hotel Charges PGE",
                                            "Toll Charges 3rd Party", 
                                            "Toll Charges PGE"
                                        ].includes(job.category));
                                        const nbJobs = allJobs.filter(job => [
                                            "Non Billable"
                                        ].includes(job.category));
                                        const npJobs = allJobs.filter(job => [
                                            "Non Production"
                                        ].includes(job.category));
                                        const realMobs = allJobs.filter(job => [
                                            "Mob PGE", 
                                            "DeMob PGE", 
                                            "Mob 3rd Party", 
                                            "DeMob 3rd Party"
                                        ].includes(job.category));
                                        const realHotels = allJobs.filter(job => [
                                            "Hotel Charges 3rd Party", 
                                            "Hotel Charges PGE"
                                        ].includes(job.category));
                                        const realTolls = allJobs.filter(job => [
                                            "Toll Charges 3rd Party", 
                                            "Toll Charges PGE"
                                        ].includes(job.category));
                                        let s = realJobs.map(job => Number(job.s)).reduce(numberReducer, 0);
                                        let o = realJobs.map(job => Number(job.o)).reduce(numberReducer, 0); 
                                        let bS = realJobs.map(job => Number(job.bS)).reduce(numberReducer, 0); 
                                        let bO = realJobs.map(job => Number(job.bO)).reduce(numberReducer, 0);
                                        let bS2 = realJobs.map(job => Number(job.bS2)).reduce(numberReducer, 0);
                                        let bO2 = realJobs.map(job => Number(job.bO2)).reduce(numberReducer, 0);
                                        const excess = s - 8;
                                        if(excess > 0){
                                            s = 8;
                                            o += excess;
                                            let total = 0;
                                            for(let i = 0; i < allJobs.length; i++){
                                                const job = allJobs[i];
                                                if("Non Billable" === job.category){
                                                    const t = Number(job.s || 0);
                                                    if(total < 8 && (total + t) <= 8){
                                                        // no change
                                                    }else if(total < 8 && (total + t) > 8){
                                                        const delta = total + t - 8;
                                                        allJobs[i].s = (Number(allJobs[i].s) - delta).toFixed(2);
                                                        allJobs[i].o = (Number(allJobs[i].o) + delta).toFixed(2);
                                                    }else if(total >= 8){
                                                        allJobs[i].s = (Number(allJobs[i].s) - t).toFixed(2);
                                                        allJobs[i].o = (Number(allJobs[i].o) + t).toFixed(2);
                                                    }
                                                    total += t;
                                                }
                                                if(![
                                                    "Rest", 
                                                    "Lunch", 
                                                    "Non Billable",
                                                    "Hotel Charges 3rd Party", 
                                                    "Hotel Charges PGE",
                                                    "Toll Charges 3rd Party", 
                                                    "Toll Charges PGE"
                                                ].includes(job.category)){
                                                    const t1 = Number(job.bS2 || 0);
                                                    const t2 = Number(job.bS || 0);
                                                    if(total < 8 && (total + t1) <= 8){
                                                        // no change
                                                    }else if(total < 8 && (total + t1) > 8){
                                                        const delta = total + t1 - 8;
                                                        bS2 -= delta;
                                                        bO2 += delta;
                                                        allJobs[i].bS2 = (Number(allJobs[i].bS2) - delta).toFixed(2);
                                                        allJobs[i].bO2 = (Number(allJobs[i].bO2) + delta).toFixed(2);
                                                    }else if(total >= 8){
                                                        bS2 -= t1;
                                                        bO2 += t1;
                                                        allJobs[i].bS2 = (Number(allJobs[i].bS2) - t1).toFixed(2);
                                                        allJobs[i].bO2 = (Number(allJobs[i].bO2) + t1).toFixed(2);
                                                    }
                                                    total += t1;
                                                    if(total < 8 && (total + t2) <= 8){
                                                        // no change
                                                    }else if(total < 8 && (total + t2) > 8){
                                                        const delta = total + t2 - 8;
                                                        bS -= delta;
                                                        bO += delta;
                                                        allJobs[i].bS = (Number(allJobs[i].bS) - delta).toFixed(2);
                                                        allJobs[i].bO = (Number(allJobs[i].bO) + delta).toFixed(2);
                                                    }else if(total >= 8){
                                                        bS -= t2;
                                                        bO += t2;
                                                        allJobs[i].bS = (Number(allJobs[i].bS) - t2).toFixed(2);
                                                        allJobs[i].bO = (Number(allJobs[i].bO) + t2).toFixed(2);
                                                    }
                                                    total += t2;
                                                }
                                            }
                                        }
                                        let bS3 = 0;
                                        let bO3 = 0;
                                        if(dayNum < 5 && s > 0){
                                            if(s <= 2){
                                                bS3 = 2 - s;
                                                s += bS3;
                                            }else if(s <= 4){
                                                bS3 = 4 - s;
                                                s += bS3;
                                            }else if(s <= 6){
                                                bS3 = 6 - s;
                                                s += bS3;
                                            }else if(s <= 8){
                                                bS3 = 8 - s;
                                                s += bS3;
                                            }
                                        }else if(o > 0){
                                            if(o <= 2){
                                                bO3 = 2 - o;
                                                o += bO3;
                                            }else if(o <= 4){
                                                bO3 = 4 - o;
                                                o += bO3;
                                            }else if(o <= 6){
                                                bO3 = 6 - o;
                                                o += bO3;
                                            }else if(o <= 8){
                                                bO3 = 8 - o;
                                                o += bO3;
                                            }
                                        }
                                        let match = false;
                                        for(let i = allJobs.length - 1; i >= 0; i--){
                                            const job = allJobs[i];
                                            if(![
                                                "Rest", 
                                                "Lunch", 
                                                "Non Billable",
                                                "Hotel Charges 3rd Party", 
                                                "Hotel Charges PGE",
                                                "Toll Charges 3rd Party", 
                                                "Toll Charges PGE"
                                            ].includes(job.category)){
                                                // allJobs[i].bO3 = bO3;
                                                // allJobs[i].bS3 = bS3;
                                                // match = true;
                                                // break;
                                                if(!match){
                                                    allJobs[i].bO3 = bO3;
                                                    allJobs[i].bS3 = bS3;
                                                    match = true;
                                                }else{
                                                    delete allJobs[i].bO3;
                                                    delete allJobs[i].bS3;
                                                }
                                            }
                                        }
                                        if(!match){
                                            const index = allJobs.findLastIndex(job => job.category === "Non Billable");
                                            if(index !== -1){
                                                allJobs[index].s = (Number(allJobs[index].s) + bS3).toFixed(2);
                                                allJobs[index].o = (Number(allJobs[index].o) + bO3).toFixed(2);
                                            }
                                            bS3 = 0;
                                            bO3 = 0;
                                        }
                                        const mobMileage = realMobs.map(job => Number(job.mobMileage || "0")).reduce(numberReducer, 0);
                                        const npMileage = npJobs.map(job => Number(job.mobMileage || "0")).reduce(numberReducer, 0);
                                        const nbMileage = nbJobs.map(job => Number(job.nbMileage || "0")).reduce(numberReducer, 0);
                                        return [
                                            {
                                                ...info, 
                                                s: s.toFixed(2), 
                                                o: o.toFixed(2), 
                                                t: (s + o).toFixed(2),
                                                bS: bS.toFixed(2), 
                                                bO: bO.toFixed(2),
                                                bS2: bS2.toFixed(2), 
                                                bO2: bO2.toFixed(2),
                                                bS3: bS3.toFixed(2),
                                                bO3: bO3.toFixed(2),
                                                bT: (bS + bO + bS2 + bO2 + bS3 + bO3).toFixed(2),
                                                h: realHotels.map(job => Number(job.expenseValue)).reduce(numberReducer, 0).toFixed(2), 
                                                to: realTolls.map(job => Number(job.expenseValue)).reduce(numberReducer, 0).toFixed(2), 
                                                billableJobNumber: billableJobNumber,
                                                mobMileage: mobMileage || 0, 
                                                nbMileage: nbMileage || 0,
                                                npMileage: Number(info.npMileage || "0"),
                                                mileage: mobMileage + npMileage + nbMileage
                                            }, 
                                            ...allJobs
                                        ];
                                    }else if(day.length === 1){
                                        return day.map((job, jobIndex) => jobIndex === 0?{
                                            ...job, 
                                            s: "0.00",
                                            o: "0.00", 
                                            t: "0.00", 
                                            bS: "0.00",
                                            bO: "0.00", 
                                            bS2: "0.00",
                                            bO2: "0.00", 
                                            bS3: "0.00",
                                            bO3: "0.00", 
                                            bT: "0.00", 
                                            billableJobNumber: "0", 
                                            mobMileage: 0,
                                            npMileage: 0, 
                                            nbMileage: 0,
                                            mileage: 0
                                        }:job)
                                    }else{
                                        return day;
                                    }
                                });
                                // weekData.otherExpensesTotal = weekData.otherExpenses.map(expense => 
                                //     Number(expense.lineTotal || 0)
                                // ).reduce(numberReducer, 0).toFixed(2);

                                weekData.hotelExpensesTotal = weekData.data.map(day => 
                                    day.slice(1).filter(
                                        job => [
                                            "Hotel Charges 3rd Party", 
                                            "Hotel Charges PGE"
                                        ].includes(job.category)
                                    )
                                )
                                .reduce(arrayReducer, [])
                                .map(job => Number(job.expenseValue))
                                .reduce(numberReducer, 0).toFixed(2);
                                weekData.tollExpensesTotal = weekData.data.map(day => 
                                    day.slice(1).filter(
                                        job => [
                                            "Toll Charges 3rd Party", 
                                            "Toll Charges PGE"
                                        ].includes(job.category)
                                    )
                                )
                                .reduce(arrayReducer, [])
                                .map(job => Number(job.expenseValue))
                                .reduce(numberReducer, 0).toFixed(2);

                                weekData.expensesTotal = 
                                (
                                    Number(weekData.hotelExpensesTotal) + 
                                    Number(weekData.tollExpensesTotal) 
                                    // Number(weekData.otherExpensesTotal)
                                ).toFixed(2);
                                weekData.s = weekData.data.map(day => 
                                Number(day[0].s))
                                .reduce(numberReducer, 0).toFixed(2);
                                
                                weekData.o = weekData.data.map(day => 
                                Number(day[0].o))
                                .reduce(numberReducer, 0).toFixed(2);

                                weekData.t = weekData.data.map(day => 
                                Number(day[0].t))
                                .reduce(numberReducer, 0).toFixed(2);
                                
                                weekData.bS = weekData.data.map(day => 
                                Number(day[0].bS))
                                .reduce(numberReducer, 0).toFixed(2);
                                
                                weekData.bO = weekData.data.map(day => 
                                Number(day[0].bO))
                                .reduce(numberReducer, 0).toFixed(2);

                                weekData.bS2 = weekData.data.map(day => 
                                Number(day[0].bS2))
                                .reduce(numberReducer, 0).toFixed(2);
                                
                                weekData.bO2 = weekData.data.map(day => 
                                Number(day[0].bO2))
                                .reduce(numberReducer, 0).toFixed(2);

                                weekData.bS3 = weekData.data.map(day => 
                                Number(day[0].bS3))
                                .reduce(numberReducer, 0).toFixed(2);
                                
                                weekData.bO3 = weekData.data.map(day => 
                                Number(day[0].bO3))
                                .reduce(numberReducer, 0).toFixed(2);

                                weekData.bT = weekData.data.map(day => 
                                Number(day[0].bT))
                                .reduce(numberReducer, 0).toFixed(2);
                                
                                weekData.mobMileage = weekData.data.map(day => day[0].mobMileage)
                                .reduce(numberReducer, 0);

                                weekData.npMileage = weekData.data.map(day => day[0].npMileage)
                                .reduce(numberReducer, 0);

                                weekData.nbMileage = weekData.data.map(day => day[0].nbMileage)
                                .reduce(numberReducer, 0);

                                weekData.mileage = weekData.data.map(day => day[0].mileage)
                                .reduce(numberReducer, 0);

                                result.push(weekData);
                            }
                            return result;
                        }else{
                            return [key, value];
                        }
                    }
            )));
            setForms(week, unordered, updateDateTime["Forms"]);
            history.replace(`/${path1}/${week}`);
        }
        if(!forms[week] || (updateDateTime["Forms"] !== forms.updatedAt)) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[week, updateDateTime, forms, history, path1, setForms])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{backgroundColor: user.userTheme}}>
                <span>
                    <Resize/>
                    Standby Outside Status
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">Week:</label>
                    <select id = "week" className = "form-control w-auto ml-2" onChange = {e => {
                        setWeek(e.currentTarget.value);
                        setCurrentPage(1);
                        history.replace(`/${path1}/${e.currentTarget.value}`);                   
                    }} value = {week}>
                        {weeks.map((k, key) => <option key = {key} value = {k}>{getDateEndFromWeekNum(k)}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "status" className = "mb-0">Status:</label>
                    <select id = "status" className = "form-control w-auto ml-2" onChange = {e => {
                        setStatus(e.currentTarget.value);
                        setCurrentPage(1);               
                    }} value = {status}>
                        <option value = "">All</option>
                        <option>Submitted</option>
                        <option value = "Created">Unsubmitted</option>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "showPayroll">Show Payroll:</label>
                    <input
                        id = "showPayroll"
                        type = "checkbox"
                        checked = {showPayroll}
                        className = "cssCheckBox ml-2"
                        onChange = {e => setShowPayroll(e.currentTarget.checked)}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "showBilling">Show Billing:</label>
                    <input
                        id = "showBilling"
                        type = "checkbox"
                        checked = {showBilling}
                        className = "cssCheckBox ml-2"
                        onChange = {e => setShowBilling(e.currentTarget.checked)}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "showMileage">Show Mileage:</label>
                    <input
                        id = "showMileage"
                        type = "checkbox"
                        checked = {showMileage}
                        className = "cssCheckBox ml-2"
                        onChange = {e => setShowMileage(e.currentTarget.checked)}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "showExpense">Show Expense:</label>
                    <input
                        id = "showExpense"
                        type = "checkbox"
                        checked = {showExpense}
                        className = "cssCheckBox ml-2"
                        onChange = {e => setShowExpense(e.currentTarget.checked)}
                    />
                </span>
                {filteredForms.length?<>
                <PMReport
                    week = {week}
                    filteredForms = {filteredForms}
                />
                <DataReport
                    week = {week}
                    filteredForms = {filteredForms}
                />
                </>:<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredForms.length?<div className = "cssLoading">Empty</div>:
                <div className = "overflow-visible">
                    <table className = "table text-center tableAllBorder">
                        <thead>
                            <tr className = "stickyHeader">
                                <th>Name</th>
                                {weekDays.map((weekday, weekdayi) => <th key = {weekdayi}>
                                    {weekday} ({getDatefromWeekNum(week, weekdayi)})
                                </th>)}
                                <th>Other Info</th>
                            </tr>
                            </thead>
                            <tbody>
                                {currentForms.map((form, formIndex) =>
                                <tr
                                    id = {form.email}
                                    key = {formIndex}
                                >
                                    <th>
                                        <div>
                                            <UserInfo 
                                                name = {form.userName}
                                                email = {form.email}
                                            />
                                        </div>
                                        <div>
                                            <span
                                                className = "mx-1 p-1 pointer"
                                                style = {{color: statusColorCode(form[week]?.status)}}
                                                onContextMenu = {e => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setFormEdit({
                                                        selectedUser: {
                                                            userName: form.userName, 
                                                            email: form.email, 
                                                            lanId: form.lanId, 
                                                            residenceState: form.residenceState, 
                                                            residence: form.residence, 
                                                            street: form.street, 
                                                            zipCode: form.zipCode, 
                                                            phoneNumber: form.phoneNumber
                                                        },
                                                        show: "Normal", 
                                                    });
                                                }}
                                            >
                                                {form[week]?.status}
                                            </span>
                                        </div>
                                        <div>
                                        <span
                                            className = "btn btn-primary p-1 ml-2 my-1"
                                            onClick = {async () => {
                                                const toRules = `To Week:\n(Example: w2022-01)\n(From Week is set to current week ${week})`;
                                                let toWeek = window.prompt(toRules);
                                                if(toWeek === null) return;
                                                while(!weeks.filter(w => w !== week).includes(toWeek)){
                                                    window.alert("Input not valid.");
                                                    toWeek = window.prompt(toRules);
                                                    if(toWeek === null) return;
                                                }
                                                if(!window.confirm(`Are you sure to switch ${week} and ${toWeek} for ${form.userName.replace(/ {2}/g, " ")}?`)) return;
                                                //-------------------------------------------------
                                                const formData = new MyFormData();
                                                formData.append("userEmail", form.email);
                                                formData.append("fromWk", week);
                                                formData.append("toWk", toWeek);
                                                //-------------------------------------------------
                                                setShowLoader(true);
                                                const res = await myAxios("outside/standby/switchWeek.php", formData);
                                                setShowLoader(false);
                                                if(!res) return;
                                                //-------------------------------------------------
                                                setForms(week, curForms.map(allForms => allForms.email === form.email?{
                                                    ...allForms, 
                                                    [week]: res.data || {
                                                        data: [
                                                        ...Array(7).fill([{}]),
                                                        ], 
                                                        otherNotes: "",
                                                        region: "",
                                                        status: "Created", 
                                                    }
                                                }:allForms));
                                            }}
                                        >
                                            Switch Week
                                        </span>
                                        </div>
                                    </th>
                                    {form[week]?.data.map((day, dayNum) => 
                                    <th key = {dayNum}>
                                        <ul className = "mb-0">
                                            {day.slice(1).map((job, jobIndex) =>
                                            ![
                                                "Hotel Charges 3rd Party", 
                                                "Hotel Charges PGE",
                                                "Toll Charges 3rd Party", 
                                                "Toll Charges PGE"
                                            ].includes(job.category)?
                                            <Fragment key = {jobIndex}>
                                            <li
                                                className = {
                                                    ["Rest", "Lunch"].includes(job.category)?`text-success`:(job.nb === 1?`text-danger`:``)
                                                }
                                            >
                                                <span className = "mr-2">{job.category}</span>
                                            </li>
                                            <ul
                                                className = {
                                                    ["Rest", "Lunch"].includes(job.category)?`text-success`:(job.nb === 1?`text-danger`:``)
                                                }
                                            >
                                                <li>{job.start?.slice(0, 16).replace("12/31/1899 ", "next day ") || "empty"}~{job.end?.slice(0, 16).replace("12/31/1899 ", "next day ") || "empty"}</li>
                                                {showPayroll && (job.s !== "0.00")?
                                                <li>Payroll ST: {job.s}h</li>
                                                :<></>}
                                                {showBilling && (job.bS2 !== "0.00")?
                                                <li className = "text-dark">Bill at Cost ST: {job.bS2}h</li>
                                                :<></>}
                                                {showBilling && (job.bS !== "0.00")?
                                                <li className = "text-dark">Billable ST: {job.bS}h</li>
                                                :<></>}
                                                {showPayroll && (job.o !== "0.00")?
                                                <li>Payroll OT: {job.o}h</li>
                                                :<></>}
                                                {showBilling && (job.bO2 !== "0.00")?
                                                <li className = "text-dark">Bill at Cost OT: {job.bO2}h</li>
                                                :<></>}
                                                {showBilling && (job.bO !== "0.00")?
                                                <li className = "text-dark">Billable OT: {job.bO}h</li>
                                                :<></>}
                                                {showPayroll && (job.t !== "0.00")?
                                                <li>Payroll Total: {job.t}h</li>
                                                :<></>}
                                                {showBilling && (job.bT !== "0.00")?
                                                <li className = "text-dark">Billing Total: {job.bT}h</li>
                                                :<></>}
                                                {showMileage?
                                                <>
                                                {job.mobMileage?
                                                <li className = "text-secondary">Mob Mileage: {job.mobMileage}</li>
                                                :<></>}
                                                {job.npMileage?
                                                <li className = "text-secondary">Jobsite Mileage: {job.npMileage}</li>
                                                :<></>}
                                                {job.nbMileage?
                                                <li className = "text-secondary">Non Billable Mileage: {job.nbMileage}</li>
                                                :<></>}
                                                </>:<></>}
                                            </ul>
                                            </Fragment>
                                            :
                                            <li key = {jobIndex} className = "text-warning">
                                                {job.category} ~ 
                                                ${job.expenseValue || "0"}
                                            </li>
                                            )}
                                        </ul>

                                        {day.length > 1 && (
                                            (showPayroll && (
                                                (day[0] && day[0].s && day[0].s !== "0.00")
                                                ||
                                                (day[0] && day[0].o && day[0].o !== "0.00")
                                            ))
                                            || 
                                            (showBilling && (
                                                (day[0] && day[0].bS2 && day[0].bS2 !== "0.00")
                                                ||
                                                (day[0] && day[0].bS3 && day[0].bS3 !== "0.00")
                                                ||
                                                (day[0] && day[0].bS && day[0].bS !== "0.00")
                                                ||
                                                (day[0] && day[0].bO2 && day[0].bO2 !== "0.00")
                                                ||
                                                (day[0] && day[0].bO3 && day[0].bO3 !== "0.00")
                                                ||
                                                (day[0] && day[0].bO && day[0].bO !== "0.00")
                                            ))
                                        )?<hr/>:<></>}
                                        {showPayroll && (day[0] && day[0].s && day[0].s !== "0.00")?
                                        <div className = "text-info">
                                            ST: {day[0].s}h
                                        </div>
                                        :<></>}
                                        {showBilling && (day[0] && day[0].bS2 && day[0].bS2 !== "0.00")?
                                        <div className = "text-dark">
                                            Bill at Cost ST: {day[0].bS2}h
                                        </div>
                                        :<></>}
                                        {showBilling && (day[0] && day[0].bS3 && day[0].bS3 !== "0.00")?
                                        <div className = "text-dark">
                                            Round up at Cost ST: {day[0].bS3}h
                                        </div>
                                        :<></>}
                                        {showBilling && (day[0] && day[0].bS && day[0].bS !== "0.00")?
                                        <div className = "text-dark">
                                            Billable ST: {day[0].bS}h
                                        </div>
                                        :<></>}
                                        {showPayroll && (day[0] && day[0].o && day[0].o !== "0.00")?
                                        <div className = "text-info">
                                            OT: {day[0].o}h
                                        </div>
                                        :<></>}
                                        {showBilling && (day[0] && day[0].bO2 && day[0].bO2 !== "0.00")?
                                        <div className = "text-dark">
                                            Bill at Cost OT: {day[0].bO2}h
                                        </div>
                                        :<></>}
                                        {showBilling && (day[0] && day[0].bO3 && day[0].bO3 !== "0.00")?
                                        <div className = "text-dark">
                                            Round up at Cost OT: {day[0].bO3}h
                                        </div>
                                        :<></>}
                                        {showBilling && (day[0] && day[0].bO && day[0].bO !== "0.00")?
                                        <div className = "text-dark">
                                            Billable OT: {day[0].bO}h
                                        </div>
                                        :<></>}

                                        {(day.length > 1) && (
                                            (showPayroll && (day[0] && day[0].t && day[0].t !== "0.00"))
                                            || 
                                            (showBilling && (day[0] && day[0].bT && day[0].bT !== "0.00"))
                                            || 
                                            (showMileage && (
                                                (day[0] && day[0].mobMileage) 
                                                || 
                                                (day[0] && day[0].npMileage) 
                                                || 
                                                (day[0] && day[0].nbMileage) 
                                                || 
                                                (day[0] && day[0].mileage)
                                            ))
                                            || 
                                            (showExpense && (
                                                (day[0] && day[0].h && day[0].h !== "0.00") 
                                                || 
                                                (day[0] && day[0].to && day[0].to !== "0.00") 
                                            ))
                                        )?<hr/>:<></>}
                                        {showPayroll && day[0] && day[0].t && day[0].t !== "0.00"?
                                        <div className = "text-info">
                                            Total: {day[0].t}h
                                        </div>
                                        :<></>}
                                        {showBilling && (day[0] && day[0].bT && day[0].bT !== "0.00")?
                                        <div className = "text-dark">
                                            Billing Total: {day[0].bT}h
                                        </div>
                                        :<></>}
                                        {showMileage?<>
                                        {day[0] && day[0].mobMileage?
                                        <div className = "text-secondary">
                                            Mob Mileage: {day[0].mobMileage}
                                        </div>
                                        :<></>}
                                        {day[0] && day[0].npMileage?
                                        <div className = "text-secondary">
                                            Jobsite Mileage: {day[0].npMileage}
                                        </div>
                                        :<></>}
                                        {day[0] && day[0].nbMileage?
                                        <div className = "text-secondary">
                                            Non Billable Mileage: {day[0].nbMileage}
                                        </div>
                                        :<></>}
                                        {day[0] && day[0].mileage?
                                        <div className = "text-secondary">
                                            Total Mileage: {day[0].mileage}
                                        </div>
                                        :<></>}
                                        </>:<></>}
                                        {showExpense?<>
                                        {day[0] && day[0].h && day[0].h !== "0.00"?
                                        <div className = "text-info">
                                            Hotel: ${day[0].h}
                                        </div>
                                        :<></>}
                                        {day[0] && day[0].to && day[0].to !== "0.00"?
                                        <div className = "text-info">
                                            Toll: ${day[0].to}
                                        </div>
                                        :<></>}
                                        </>:<></>}
                                    </th>
                                    )}
                                    <th>
                                        {form[week]?.region?
                                        <div className = "text-primary">
                                            Region: {form[week].region}
                                        </div>
                                        :<></>}
                                        {form[week]?.otherNotes?
                                        <div className = "text-info cssNotes">
                                            Other Notes: {form[week].otherNotes}
                                        </div>:<></>}
                                        {/*
                                        form[week]?.otherExpenses && form[week].otherExpenses.length > 0?
                                        <ul className = "mb-0">
                                            Other Expenses:
                                            {form[week].otherExpenses.map((expense,expenseIndex) => 
                                            <li key = {expenseIndex}>
                                                {expense.expenseDate} - {expense.expenseType} - {expense.expenseUnit} x ${expense.expenseRate} = ${expense.lineTotal}
                                            </li>
                                            )}
                                            Other Expenses Total: ${form[week].otherExpensesTotal}
                                        </ul>
                                        :<></>
                                        */}
                                        {form[week]?.hotelExpensesTotal && form[week].hotelExpensesTotal !== "0.00"?
                                        <div>
                                            Hotel Expenses Total: ${form[week].hotelExpensesTotal}
                                        </div>
                                        :<></>}
                                        {form[week]?.tollExpensesTotal && form[week].tollExpensesTotal !== "0.00"?
                                        <div>
                                            Toll Expenses Total: ${form[week].tollExpensesTotal}
                                        </div>
                                        :<></>}
                                        {form[week]?.expensesTotal && form[week].expensesTotal !== "0.00"?
                                        <div>
                                            Expenses Total: ${form[week].expensesTotal}
                                        </div>
                                        :<></>}
                                        {showPayroll &&form[week]?.s && form[week].s !== "0.00"?
                                        <div>
                                            ST: {form[week].s}
                                        </div>
                                        :<></>}
                                        {form[week]?.bS2 && form[week].bS2 !== "0.00"?
                                        <div className = "text-info">
                                            Bill at Cost ST: {form[week].bS2}
                                        </div>
                                        :<></>}
                                        {form[week]?.bS3 && form[week].bS3 !== "0.00"?
                                        <div className = "text-info">
                                            Rpund up Bill at Cost ST: {form[week].bS3}
                                        </div>
                                        :<></>}
                                        {form[week]?.bS && form[week].bS !== "0.00"?
                                        <div className = "text-info">
                                            Billable ST: {form[week].bS}
                                        </div>
                                        :<></>}
                                        {form[week]?.o && form[week].o !== "0.00"?
                                        <div>
                                            OT: {form[week].o}
                                        </div>
                                        :<></>}
                                        {form[week]?.bO2 && form[week].bO2 !== "0.00"?
                                        <div className = "text-info">
                                            Bill at Cost OT: {form[week].bO2}
                                        </div>
                                        :<></>}
                                        {form[week]?.bO3 && form[week].bO3 !== "0.00"?
                                        <div className = "text-info">
                                            Round up Bill at Cost OT: {form[week].bO3}
                                        </div>
                                        :<></>}
                                        {form[week]?.bO && form[week].bO !== "0.00"?
                                        <div className = "text-info">
                                            Billable OT: {form[week].bO}
                                        </div>
                                        :<></>}
                                        {form[week]?.t && form[week].t !== "0.00"?
                                        <div>
                                            Total: {form[week].t}
                                        </div>
                                        :<></>}
                                        {form[week]?.bT && form[week].bT !== "0.00"?
                                        <div className = "text-info">
                                            Billing Total: {form[week].bT}
                                        </div>
                                        :<></>}
                                        {form[week]?.mobMileage && form[week].mobMileage !== 0?
                                        <div className = "text-secondary">
                                            Mob Mileage: {form[week].mobMileage}
                                        </div>
                                        :<></>}
                                            {form[week]?.npMileage && form[week].npMileage !== 0?
                                        <div className = "text-secondary">
                                            Jobsite Mileage: {form[week].npMileage}
                                        </div>
                                        :<></>}
                                        {form[week]?.nbMileage && form[week].nbMileage !== 0?
                                        <div className = "text-secondary">
                                            Non Billable Mileage: {form[week].nbMileage}
                                        </div>
                                        :<></>}
                                        {form[week]?.mileage && form[week].mileage !== 0?
                                        <div className = "text-secondary">
                                            Total Mileage: {form[week].mileage}
                                        </div>
                                        :<></>}
                                        {form[week]?.id?
                                        <a 
                                            className = "mb-1 btn btn-primary"
                                            href = {`https://drive.google.com/file/d/${form[week].id}`}
                                            target = "_blank"
                                            rel = "noreferrer"
                                            id = {form[week].id}
                                        >
                                            Payroll
                                        </a>:<></>}
                                        {form[week]?.billableId?
                                        <a 
                                            className = "mb-1 ml-1 btn btn-success"
                                            href = {`https://drive.google.com/file/d/${form[week].billableId}`}
                                            target = "_blank"
                                            rel = "noreferrer"
                                            id = {form[week].billableId}
                                        >
                                            Billable
                                        </a>:<></>}
                                    </th>
                                </tr>
                                )}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredForms.length?
                <Footer
                    length = {filteredForms.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
            {formEdit.show === "Normal"?
            <StandByForm
                closeIt = {() => {
                    setFormEdit({show: false});
                }}
                defaultData = {curForms.find(f => 
                    f.email === formEdit.selectedUser.email
                )?.[week]}
                prevData = {curForms.find(f => 
                    f.email === formEdit.selectedUser.email
                )?.[changeWeek(week, -1)]}
                week = {week}

                selectedUser = {formEdit.selectedUser}
                admin = {true}
                email = {formEdit.selectedUser.email}
            />:<></>}
        </div>
    )
}